import React, { lazy, Suspense } from "react";
import { withPreloadedJSON } from "@wss/hypernova";
import { env } from "~/common/Environment";
const LazyStoreFrontBanner = lazy(() => {
  return import(".").then(({
    default: StoreFrontBanner
  }) => {
    const StoreFrontBannerWithData = withPreloadedJSON(StoreFrontBanner, "StoreFrontBanner");
    return {
      default: () => <StoreFrontBannerWithData />
    };
  });
});
export function StoreFrontBanner() {
  return <>
      {!env.isProd ? <Suspense>
          <LazyStoreFrontBanner />
        </Suspense> : null}
    </>;
}